import { Star, Users, CarFront, Plane } from "lucide-react";

const items = [
  { icon: Star, title: "4.9/5 rating", sub: "From 5,000+ travelers" },
  { icon: Plane, title: "5 airports", sub: "PUJ · SDQ · STI · POP · LRM" },
  { icon: CarFront, title: "Private only", sub: "No shared shuttles" },
  { icon: Users, title: "1–40 passengers", sub: "Sedans to buses" },
];

const TrustBar = () => (
  <section aria-label="Why travelers choose us" className="bg-navy-light border-y border-border/10">
    <div className="container mx-auto px-4">
      <ul className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-border/10">
        {items.map((i) => (
          <li key={i.title} className="flex items-center gap-3 px-4 py-5">
            <span className="w-10 h-10 rounded-lg bg-primary/15 flex items-center justify-center shrink-0">
              <i.icon className="w-5 h-5 text-primary" aria-hidden="true" />
            </span>
            <span className="min-w-0">
              <span className="block font-sans font-semibold text-hero-foreground text-sm">{i.title}</span>
              <span className="block font-sans text-hero-foreground/80 text-xs truncate">{i.sub}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default TrustBar;
